// tslint:disable:max-line-length
import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MenuLink } from './common-theme/base-components/shared/menu/menu-link.model';
import { AgencyService } from './common-theme/api/agency.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material';
import {
  ShowItemDetailsModalBaseComponent
} from './common-theme/base-components/shared/modals/show-item-details-modal-base/show-item-details-modal-base.component';
import {
  ShowBlackFridayModalComponent
} from './common-theme/base-components/shared/modals/show-black-friday-modal/show-black-friday-modal.component';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, OnInit {
  subscription: Subscription;
  pageHeight: number;
  public currentRoute: string = '/';
  public links: MenuLink[] = [
    new MenuLink('', 'acasă', []),
    new MenuLink('contacteaza-ne', 'contact', []),
    new MenuLink('despre-noi', 'despre noi', []),
    new MenuLink('localizare', 'localizare', []),
    new MenuLink(
      'apartamente-noi-rahova-salaj-sector5-bucuresti',
      'locuințe',
      []
    ),
    new MenuLink('parcari', 'parcări', []),
    new MenuLink('parteneri', 'parteneri', []),
    new MenuLink('galerie', 'galerie', [])
  ];

  constructor(
    public agencyService: AgencyService,
    private meta: Meta,
    private dialog: MatDialog,
    router: Router,
    @Inject('WINDOW') private window: any,
    translate: TranslateService
  ) {
    if (router) {
      router.events.subscribe(s => {
        if (s instanceof NavigationEnd) {
          const tree = router.parseUrl(router.url);
          this.currentRoute = router.url;
          this.meta.removeTag('name=\'robots\'');

          if (!tree.fragment) {
            if (this.window) {
              this.window.scrollTo(0, 0);
            }
          }
        }
      });
    }

    translate.setDefaultLang('ro');
    translate.use('ro');
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    if (this.window) {
      setTimeout(() => this.showBlackFridayPopup(), 1500);
    }
  }

  showDisclaimerContent(): void {
    this.dialog.open(
      ShowItemDetailsModalBaseComponent,
      {
      data: {
        title: 'Informații',
        description: `Stimați clienti,

Datorită informațiilor care se vehiculează in media in legătură cu creșterea taxelor, a TVA-ului, etc, va anunțăm ca este posibil ca prețurile imobilelor sa crească intre 10 si 20%.

Rezervați acum apartamentul dorit si securizați-va prețul!

Va mulțumim!`,
        cta: 'Am luat la cunoștință'
      }
      }
    );
  }

  showBlackFridayPopup(): void {
    this.dialog.open(
      ShowBlackFridayModalComponent,
      {
        data: {
          imageUrl: '/assets/images/home/bf.jpeg'
        },
        maxHeight: '90vh',
        maxWidth: '90vw',
        autoFocus: false
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts